import Confirm from '@/components/Confirm'
import { Checkbox, States as CheckboxStates } from '@/components/Checkbox'
import useTranslation from '@/Hooks/useTranslation'

export interface ReliquatPopupLine {
   sku: string
   label: string
   origQty: number
   curQty: number
   reliquat: number
}

interface ReliquatConfirmProps {
   /** Titre de la popup (ex. "Soumettre" / "Validation finale" selon l'étape). */
   title: string
   /** Lignes refusées (qté réduite/supprimée par le valideur p/r à la demande client). */
   lines: ReliquatPopupLine[]
   /** Cases cochées (mêmes index que `lines`) : lignes à reporter dans le reliquat. */
   checked: boolean[]
   /** Bascule la case d'index i. */
   onToggle: (i: number) => void
   onOK: () => void
   onCancel: () => void
}

/**
 * Popup unique « Reliquat détecté » : liste les lignes dont la quantité a été réduite/supprimée
 * lors de la validation et propose (cases à cocher) de les reporter dans une commande de reliquat.
 * Partagée par les 3 chemins de validation (menu Orders, menu OrderDetail, bouton vert de la table
 * de validation) pour garantir un comportement et un rendu identiques.
 */
export default function ReliquatConfirm({ title, lines, checked, onToggle, onOK, onCancel }: ReliquatConfirmProps) {
   const { trans } = useTranslation()
   return (
      <Confirm
         title={title}
         text={trans('?Reliquat détecté')}
         onOK={onOK}
         onCancel={onCancel}
         minWidth={'42%'}
         maxWidth={'56%'}
      >
         <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', margin: '8px 0', fontSize: '0.9em' }}>
               <thead>
                  <tr style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>
                     <th style={{ padding: '4px' }}></th>
                     <th style={{ padding: '4px' }}>{trans('?Référence')}</th>
                     <th style={{ padding: '4px' }}>{trans('?Intitulé')}</th>
                     <th style={{ padding: '4px', textAlign: 'right' }}>{trans('?Init.')}</th>
                     <th style={{ padding: '4px', textAlign: 'right' }}>{trans('?Final')}</th>
                     <th style={{ padding: '4px', textAlign: 'right' }}>{trans('?Reliq.')}</th>
                  </tr>
               </thead>
               <tbody>
                  {lines.map((line, i) => (
                     <tr key={line.sku} style={{ borderBottom: '1px solid #eee', cursor: 'pointer' }}
                        onClick={() => onToggle(i)}>
                        <td style={{ padding: '4px' }}>
                           <Checkbox small checked={checked[i] ? CheckboxStates.Checked : CheckboxStates.Unchecked}
                              onChange={() => onToggle(i)} />
                        </td>
                        <td style={{ padding: '4px' }}>{line.sku}</td>
                        <td style={{ padding: '4px', fontSize: '0.85em' }}>{line.label}</td>
                        <td style={{ padding: '4px', textAlign: 'right' }}>{line.origQty}</td>
                        <td style={{ padding: '4px', textAlign: 'right' }}>{line.curQty}</td>
                        <td style={{ padding: '4px', textAlign: 'right', fontWeight: 'bold' }}>{line.reliquat}</td>
                     </tr>
                  ))}
               </tbody>
            </table>
         </div>
      </Confirm>
   )
}
